import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { LockIcon, DownloadIcon } from 'lucide-react';
export function OfferBlock() {
  return <section id="offer" className="py-24 bg-cream text-text-dark relative" data-id="element-99">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
        <FadeIn data-id="element-101">
          <div className="bg-white rounded-3xl p-8 md:p-16 border-2 border-gold shadow-2xl text-center relative overflow-hidden" data-id="element-102">
            {/* Subtle background accent */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-103"></div>

            <div className="relative z-10" data-id="element-104">
              <p className="text-xl md:text-2xl text-text-muted font-serif mb-6" data-id="element-105">
                No necesitas pagar{' '}
                <span className="line-through text-red-400" data-id="element-106">
                  $150 mensuales
                </span>{' '}
                a una agencia...
              </p>

              <div className="mb-8" data-id="element-107">
                <span className="text-6xl md:text-8xl font-bold text-navy font-serif tracking-tight" data-id="element-108">
                  $6.39
                </span>
                <span className="text-xl text-gold font-bold uppercase tracking-widest ml-2" data-id="element-109">
                  USD
                </span>
                <p className="text-sm font-bold text-text-muted uppercase tracking-widest mt-2" data-id="element-110">
                  Pago Único
                </p>
              </div>

              <p className="text-lg text-text-dark font-sans max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-111">
                Menos de lo que cuesta una cena, para una herramienta que te
                ahorrará miles en intereses el resto de tu vida.
              </p>

              <div className="max-w-md mx-auto space-y-6" data-id="element-112">
                <Button fullWidth className="text-xl py-5" onClick={() => window.open('https://mapadecreditocleanslate.com//cart/47632652697774:1', '_blank')} data-id="element-113">
                  ¡QUIERO MI CLEAN SLATE AHORA!
                </Button>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-text-muted font-sans font-medium" data-id="element-114">
                  <div className="flex items-center gap-2" data-id="element-115">
                    <DownloadIcon className="w-4 h-4 text-gold" data-id="element-116" />
                    Descarga instantánea
                  </div>
                  <div className="hidden sm:block text-gray-300" data-id="element-117">•</div>
                  <div className="flex items-center gap-2" data-id="element-118">
                    <LockIcon className="w-4 h-4 text-gold" data-id="element-119" />
                    Pago seguro
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}